import React from 'react'
import { ActivityIndicator, Text, View } from 'react-native'

import { B1, SH3 } from '@zet/design-system'

type Props = {
  emi?: number
  interestRate?: number
  isLoading?: boolean
  isValid?: boolean
}

export const EmiCalculatedValues = (props: Props) => {
  const { isLoading = false, emi, interestRate, isValid } = props
  const isShowValues = isValid && !isLoading
  const _emi = (isShowValues && emi) || '--'
  const _interestRate = (isShowValues && interestRate) || '--'

  return (
    <View className="bg-primary-200 px-4 pt-4">
      <View className="bg-primary-10 items-center justify-center rounded-t-lg p-3">
        <ActivityIndicator
          className="absolute right-2 top-2"
          animating={isValid && isLoading}
        />
        <B1 className="my-1 font-[Graphie-Bold]">Monthly EMI</B1>
        <Text className="text-primary-200 my-2 font-[Graphie-Bold] text-2xl">
          ₹ {_emi}
        </Text>
        <SH3 className="bg-grays-10 my-2 rounded px-2 py-1">
          Loan Interest Rate = {_interestRate}%
        </SH3>
      </View>
    </View>
  )
}
